<script>
import isObject from 'lodash/isObject';

export default {
  props: {
    label: String,
    value: [String, Number],
    rules: String,
    vid: String,
    options: [Array, Object],
    loading: Boolean,
    small: [Boolean, String],
    disabled: [Boolean, String],

    // for when you dont want to use a label but need a custom validator
    name: String,

    // only usable when options array is null
    passwordReveal: [Boolean, String],
    type: String,

    // only usable when options array is not null
    placeholder: String,
    valueProperty: String,
    textProperty: String,
    isKeyValue: [Boolean, String],

    // only usable when isKeyValue is true
    reversedKeyValue: [Boolean, String],
  },
  data: () => ({
    isObject,
    initialized: false,
  }),
  computed: {
    mutatableValue: {
      get() {
        return this.value;
      },
      set(value) {
        if (this.initialized) {
          this.$emit('input', value);
        }
      },
    },
  },
  created() {
    this.mutatableValue = this.value;

    this.initialized = true;
  },
};
</script>

<template lang='pug'>
validate(
  tag='div',
  :name='label || name',
  :rules='rules',
  :vid='vid',
  v-slot='{ errors }',
)
  b-field(
    expanded,
    label-position='inside',
    :label='label',
    :message='errors',
    :type='{ "is-danger": errors[0] }',
  )
    b-input(
      v-if='!options',
      v-model='mutatableValue',
      expanded,
      :disabled='disabled',
      :type='type',
      :password-reveal='passwordReveal',
      :loading='loading',
      :size='small ? "is-small" : null',
      @keydown.native='$emit("keydown", $event)',
    )
    b-select(
      v-else,
      v-model='mutatableValue',
      expanded,
      :disabled='disabled',
      :placeholder='placeholder',
      :loading='loading',
      :size='small ? "is-small" : null',
    )
      template(v-if='valueProperty && textProperty')
        option(
          v-for='option in options',
          :value='option[valueProperty]',
        ) {{option[textProperty]}}
      template(v-else-if='isKeyValue')
        template(v-if='reversedKeyValue')
          option(
            v-for='(text, value) in options',
            :value='text',
          ) {{value}}
        template(v-else)
          option(
            v-for='(text, value) in options',
            :value='value',
          ) {{text}}
      template(v-else)
        option(
          v-for='(text, value) in options',
          :value='isObject(text) ? value : text',
        ) {{text}}
</template>

<style>

</style>